import { Button, Card, Col, Container, DatePicker, Form, FormCheckbox, FormInput, FormSelect, ListGroup, ListGroupItem, Row } from "shards-react";
import ActionBar from "../../common/ActionBar";
import InputBox from "../../common/InputBox";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
    get_new_payComponent_name_list,
    get_record_frequency_list,
    get_pay_item,
    get_rate_unit_of_measure_name_list,
    save_pay_item,
    delete_pay_items,
    reset_pay_item,
    get_pay_component,
    get_compensation_payee_list,
    get_compensation_payee_list_byworker,
    get_pay_schedule_list,
    calculate_invoice_rate,
} from "../../../redux/actions/subscriber/payroll";
import { setAPIDate, setInputDate } from "../../../utils/date";
import { fixedDecimalPlaces, formatNumberAmount, toNumber } from "../../../utils/general";
import ConfirmAlert from "../../common/ConfirmAlert";
import StandardFormInput from "../../common/StandardFormInput";
import { STANDARD_FORMATS } from "../../../utils/constants";
import { get_sub_config, get_client_information } from "../../../redux/actions/user";
import { get_client_allowed_payschedule, get_current_payschedule } from "../../../redux/actions/subscriber/subscriberUsers";
import ReactTable from "react-table";
import CRBadge from '../../common/CRBadge';

function PayItemForm({ newPayComponentNameList,
    rateUnitofMeasureNameList,
    recordFrequencyList,
    payItem,
    payComponent,
    compensationPayeeList,
    subConfigList,
    get_new_payComponent_name_list,
    get_rate_unit_of_measure_name_list,
    get_record_frequency_list,
    save_pay_item,
    get_pay_item,
    delete_pay_items,
    changePageMeta,
    reset_pay_item,
    get_pay_component,
    get_compensation_payee_list,
    get_compensation_payee_list_byworker,
    get_sub_config,

    get_pay_schedule_list,
    payScheduleList,
    clientAllowPaySchduleList,
    get_client_allowed_payschedule,
    get_current_payschedule,
    currentPayItemPaySchedule,
    calculate_invoice_rate,
    dynamicInvoiceRate,
    get_client_information,
    clientInformation,
}) {
    const tableRef = useRef()
    const [tableData, setTableData] = useState([
        { refNum : 1, checked : false, prop: "workplaceComp", employerCost : "Workplace Injury Compensation", rate : "", amount : "" },
        { refNum : 2, checked : false, prop: "healthTax", employerCost : "Health Tax (EHT)", rate : "", amount : "" },
        { refNum : 3, checked : false, prop: "govtPension1", employerCost : "Government Pension Plan 1 (CPP)", rate : "", amount : "" },
        { refNum : 4, checked : false, prop: "govtPension2", employerCost : "Government Pension Plan 2 (CPP 2)", rate : "", amount : "" },
        { refNum : 5, checked : false, prop: "employmentInsurance", employerCost : "Employment Insurance (EI)", rate : "", amount : "" },
    ]);

    const location = useLocation();
    const [formData, setFormData] = useState({
        payItemRefNum: (location.state && location.state.refNum) ? location.state.refNum : 0,
        workerUserId: (location.state && location.state.formData) ? location.state.formData.userId : 0,
        payComponent: '',
        payComponentId: 0,
        payRate: 0,
        invoiceRate: '',
        rateUnitOfMeasure: '',
        payFrequency: '',
        invoiceFrequency: '',
        startDate: '',
        endDate: '',
        payDate: '',
        invoiceDate: '',
        note: '',
        isDeleted: false,
        taxRate:'',
        defaultCompensationMethod:'',
        //Added new by nipsy
        paySchedule: '',
        payableRateUnitOfMeasure: '',
        currentPaySchedule: 0,
        // Added new by nipul for dynamic invoice rate
        includePayRateInInvoiceRate: false,
        includeWorkplaceComp: false,
        includeHealthTax: false,
        includeGovtPension1: false,
        includeGovtPension2: false,
        includeEmploymentInsurance: false,
        calculatedInvoiceRate: 0,
    })

    const [employerCost, setEmployerCost] = useState({
        payRateInInvoiceRate: 0,
        workplaceComp: 0,
        healthTax: 0,
        govtPension1: 0,
        govtPension2: 0,
        employmentInsurance: 0,
        calculatedInvoiceRate: 0,
    })

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });
    const [formSubmitting, setForSubmitting] = useState(false);
    const history = useHistory();

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }
    const onChangeStandardInput = (name, value) => {
        setFormData({ ...formData, [name]: value })
    };

    const onMonetaryAmountChanged = (e, decimalPlaces) => {
        setFormData({ ...formData, [e.target.name]: toNumber(e.target.value, decimalPlaces) })
    };

    const onCheck = (refNum) => {
        
        let checkedTableData = tableData.map(data => {
            if (data.refNum === refNum) {
                data.checked = !data.checked
                switch (data.prop) {
                    case 'workplaceComp':
                        setFormData({ ...formData, includeWorkplaceComp: data.checked })  
                        break
                    case 'healthTax':
                        setFormData({ ...formData, includeHealthTax: data.checked })  
                        break
                    case 'govtPension1':
                        setFormData({ ...formData, includeGovtPension1: data.checked })  
                        break
                    case 'govtPension2':
                        setFormData({ ...formData, includeGovtPension2: data.checked })  
                        break
                    case 'employmentInsurance':
                        setFormData({ ...formData, includeEmploymentInsurance: data.checked })  
                        break
                }
            }

            return data;
        })

        setTableData(checkedTableData);
    }
    const checkAll = (e) => {

        let checkedTableData = tableData.map(data => {
            data.checked = e.target.checked;
            return data;
        })

        setFormData({ ...formData
            , includeWorkplaceComp: e.target.checked
            , includeHealthTax: e.target.checked
            , includeGovtPension1: e.target.checked
            , includeGovtPension2: e.target.checked
            , includeEmploymentInsurance: e.target.checked
        })
        setTableData(checkedTableData);
    }
    const isAllChecked = () => {
        if (tableData.length === 0) return false

        for (let data of tableData) {
            if (!data.checked) {
                return false;
            }
        }
        return true;
    }

    const propToPayItemField = {
        workplaceComp:       'includeWorkplaceComp',
        healthTax:           'includeHealthTax',
        govtPension1:        'includeGovtPension1',
        govtPension2:        'includeGovtPension2',
        employmentInsurance: 'includeEmploymentInsurance',
    };

    const tableColumns = [
        {
            Header: <FormCheckbox checked={isAllChecked()} onClick={(e) => checkAll(e)}></FormCheckbox>,
            accessor: "action",
            maxWidth: 100,
            minWidth: 100,
            sortable: false,
            Cell: row => {
                const field = propToPayItemField[row.original.prop];
                const hasCR = payItem[field]?.isChangeRequested;
                const crNewVal = payItem[field]?.newvalue;
                const crDisplay = crNewVal === 'true' ? 'True' : crNewVal === 'false' ? 'False' : crNewVal;
                return (
                    <div className="d-flex align-items-center">
                        <FormCheckbox checked={row.original.checked} key={row.original.refNum} onClick={() => onCheck(row.original.refNum)} />
                        {hasCR && <CRBadge newValue={crDisplay} />}
                    </div>
                );
            }
        },
        {
            Header: "Employer Burden Costs",
            accessor: "employerCost",
            maxWidth: 310,
            minWidth: 310,
        },
        {
            Header: "Rate (%)",
            accessor: "rate",
            minWidth: 100,            
            Cell: row => <span className="w-100 ">{ row.original.rate }</span>
        },
        {
            Header: "Amount",
            accessor: "amount",
            maxWidth: 100,
            minWidth: 100,
            Cell: row => <span className="w-100">{ row.original.amount }</span>
        }
    ]

    const back = ()=>{
        let userId = formData.workerUserId === undefined ? 0 : formData.workerUserId;
        let roleStr = (formData.workerUserId !== undefined && location.state.role !== undefined) ? `?role=${location.state.role}` : '?role=';

        history.push({
            pathname: `/manage-user-profile/${userId}`,
            search: `${roleStr}&section=payItem&subSection=payItem`,
            state: {  formData: location.state.formData, formDataRef: location.state.formDataRef, sectionformDataRef: location.state.sectionformDataRef },
        });
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if(formSubmitting) return;
        setForSubmitting(true);
        let formDataToSubmit = { ...formData }
        formDataToSubmit.startDate = setInputDate(formDataToSubmit.startDate)
        formDataToSubmit.endDate = setInputDate(formDataToSubmit.endDate)
        formDataToSubmit.payDate = setInputDate(formDataToSubmit.payDate)
        formDataToSubmit.invoiceDate = setInputDate(formDataToSubmit.invoiceDate)
        let saved = await save_pay_item(JSON.stringify(formDataToSubmit))

        if (saved) back();
        setForSubmitting(false)
    }

    const onDelete = () => {

        setConfirmAlert({
            ...confirmAlert,
            confirmMsg: 'Do you want to Delete the Pay Item?',
            visible: true,
            onConfirm: async () => {

                let deleted = await delete_pay_items(formData.payItemRefNum);
                if (deleted) back();

            }
        })
    }

    const onCalculatingRates = async (e) => {
        e.preventDefault();
        let fetched = await calculate_invoice_rate(
            formData.payItemRefNum, formData.includePayRateInInvoiceRate,
            formData.includeWorkplaceComp, formData.includeHealthTax,
            formData.includeGovtPension1, formData.includeGovtPension2,
            formData.includeEmploymentInsurance
        );
    }

    const newPayComponentNameListOptions = (newPayComponentNameList || []).map((payComponent, i) => <option key={payComponent.payComponentName + i} value={payComponent.payComponentId}>{payComponent.payComponentName}</option>)
    const rateUnitofMeasureNameListOptions = (rateUnitofMeasureNameList || []).map((unitOfmeasure, i) => <option key={unitOfmeasure + i} value={unitOfmeasure}>{unitOfmeasure}</option>)
    const payFrequencyListOptions = (recordFrequencyList || []).map((payFrequency, i) => <option key={payFrequency + i} value={payFrequency} >{payFrequency}</option>)
    const invoiceFrequencyListOptions = (recordFrequencyList || []).map((payFrequency, i) => <option key={'invoice' + payFrequency + i} value={payFrequency} >{payFrequency}</option>)
    const compensationPayeeListOptions = (compensationPayeeList || []).map(compensationPayee => <option key={compensationPayee.refId} value={compensationPayee.refId}>{compensationPayee.payeeName}</option>)
    //const payScheduleListOptions = payScheduleList.map(paySchedule => <option key={paySchedule.payScheduleName + paySchedule.payScheduleRefNum} value={paySchedule.payScheduleRefNum}>{paySchedule.payScheduleName}</option>)
    const payScheduleListOptions = (clientAllowPaySchduleList || []).map(paySchedule => <option key={paySchedule.payScheduleName + paySchedule.payScheduleRefNum} value={paySchedule.payScheduleRefNum}>{paySchedule.payScheduleName}</option>)
    
    const v = (f) => (f !== null && f !== undefined && typeof f === 'object' && 'currentvalue' in f)
        ? f.currentvalue
        : f;

    const toBoolean = (f) => {
        const val = v(f);
        if (val === true  || val === 'true')  return true;
        if (val === false || val === 'false') return false;
        return !!val;
    };
    console.log("formData.currentPaySchedule => ", typeof(formData.currentPaySchedule))
    console.log("payScheduleList => ", payScheduleList)
    console.log("formData.currentPaySchedule)[0]?.payScheduleName => ", payScheduleList.filter(x => x.payScheduleRefNum === formData.currentPaySchedule))


    const getFormData = (payItem) => {
        return {
            payItemRefNum:               v(payItem.payItemRefNum)               || formData.payItemRefNum,
            workerUserId:                v(payItem.workerUserId)                || formData.workerUserId,
            payComponentId:              v(payItem.payComponentId)              || formData.payComponentId,
            payComponent:                v(payItem.payComponent)                || formData.payComponent,
            payRate:                     v(payItem.payRate)     && fixedDecimalPlaces(Number(v(payItem.payRate)), 4)     || formData.payRate,
            invoiceRate:                 v(payItem.invoiceRate) && fixedDecimalPlaces(v(payItem.invoiceRate), 4)         || formData.invoiceRate,
            rateUnitOfMeasure:           v(payItem.rateUnitOfMeasure)           || formData.rateUnitOfMeasure,
            payFrequency:                v(payItem.payFrequency)                || formData.payFrequency,
            invoiceFrequency:            v(payItem.invoiceFrequency)            || formData.invoiceFrequency,
            startDate:                   setAPIDate(v(payItem.startDate))       || formData.startDate,
            endDate:                     setAPIDate(v(payItem.endDate))         || formData.endDate,
            payDate:                     setAPIDate(v(payItem.payDate))         || formData.payDate,
            invoiceDate:                 setAPIDate(v(payItem.invoiceDate))     || formData.invoiceDate,
            note:                        v(payItem.note)                        || formData.note,
            isDeleted:                   v(payItem.isDeleted)                   || formData.isDeleted,
            taxRate:                     v(payItem.taxRate)     && fixedDecimalPlaces(v(payItem.taxRate), 4)             || formData.taxRate,
            defaultCompensationMethod:   v(payItem.defaultCompensationMethod)   || formData.defaultCompensationMethod,
            payableRateUnitOfMeasure:    v(payItem.payableRateUnitOfMeasure)    || formData.payableRateUnitOfMeasure,
            paySchedule:                 v(payItem.paySchedule)                 || formData.paySchedule,
            currentPaySchedule:          v(payItem.currentPaySchedule)          || formData.currentPaySchedule,
            includePayRateInInvoiceRate: 'includePayRateInInvoiceRate' in payItem ? toBoolean(payItem.includePayRateInInvoiceRate) : formData.includePayRateInInvoiceRate,
            includeWorkplaceComp:        'includeWorkplaceComp'        in payItem ? toBoolean(payItem.includeWorkplaceComp)        : formData.includeWorkplaceComp,
            includeHealthTax:            'includeHealthTax'            in payItem ? toBoolean(payItem.includeHealthTax)            : formData.includeHealthTax,
            includeGovtPension1:         'includeGovtPension1'         in payItem ? toBoolean(payItem.includeGovtPension1)         : formData.includeGovtPension1,
            includeGovtPension2:         'includeGovtPension2'         in payItem ? toBoolean(payItem.includeGovtPension2)         : formData.includeGovtPension2,
            includeEmploymentInsurance:  'includeEmploymentInsurance'  in payItem ? toBoolean(payItem.includeEmploymentInsurance)  : formData.includeEmploymentInsurance,
        }
    }
    useEffect(()=>{
        if(formData.payItemRefNum === 0 && formData.payComponentId !== 0){
            get_pay_component(formData.payComponentId);
        }
    },[formData.payComponentId])

    useEffect(()=>{
        setFormData({...formData, taxRate: fixedDecimalPlaces(payComponent.taxRate, 4)})
    },[payComponent])

    useEffect(() => {
        get_pay_schedule_list();
        if(location.state.formData != null){
            get_client_allowed_payschedule(location.state.formData.clientId);
        }
        changePageMeta(`Pay Item - ${location.state && location.state.formData && location.state.formData.firstName + ' ' + location.state.formData.lastName + ' ' + (location.state.formData.nickName !== '' ?`(${location.state.formData.nickName})` : '' )}`)
        get_sub_config();
        if (formData.payItemRefNum !== 0) {
            get_pay_item(formData.payItemRefNum);
        }
        else if(location.state.formData != null){
            get_current_payschedule(location.state.formData.clientId);
            if (location.state.formData.clientId) {
                get_client_information(location.state.formData.clientId);
            }
        }
        get_new_payComponent_name_list();
        get_rate_unit_of_measure_name_list();
        get_record_frequency_list();
        if(formData.workerUserId !== undefined || formData.workerUserId > 0)
            get_compensation_payee_list_byworker(formData.workerUserId);
        else
            get_compensation_payee_list();
        return reset_pay_item;
    }, [])

    useEffect(() => {
        setFormData({ ...getFormData(payItem) })
        //Set checkbox values 
        let revisedData = [...tableData];
        if(Object.keys(payItem).length > 0){
            revisedData.map(x => {
                x.rate = "";
                x.amount = "";
                if(x.prop === "workplaceComp") {
                    x.checked = toBoolean(payItem.includeWorkplaceComp)
                }
                if(x.prop === "healthTax") {
                    x.checked = toBoolean(payItem.includeHealthTax)
                }
                if(x.prop === "govtPension1") {
                    x.checked = toBoolean(payItem.includeGovtPension1)
                }
                if(x.prop === "govtPension2") {
                    x.checked = toBoolean(payItem.includeGovtPension2)
                }
                if(x.prop === "employmentInsurance") {
                    x.checked = toBoolean(payItem.includeEmploymentInsurance)
                }
                
                return x;
            })
        }
        
        setTableData(revisedData);
    }, [payItem])

    useEffect(()=>{
        if(formData.payItemRefNum === 0){
        const subConfig = (subConfigList || []).reduce((obj1, obj2) => {
            obj1[obj2.field] = obj2.value;
            return obj1;
        }, {});
        if(subConfig.defaultCompensationMethod){
            setFormData({...formData, defaultCompensationMethod:subConfig.defaultCompensationMethod});
        }
    }
    },[subConfigList])

    useEffect(() => {
        if(currentPayItemPaySchedule !== null && currentPayItemPaySchedule !== undefined){
            setFormData({ ...formData, currentPaySchedule: currentPayItemPaySchedule.payScheduleRefNum })
        }
    }, [currentPayItemPaySchedule])

    useEffect(() => {
        if (formData.payItemRefNum === 0 && clientInformation) {
            setFormData((prev) => ({
                ...prev,
                payFrequency: clientInformation.defaultPayFrequencyName || prev.payFrequency,
                invoiceFrequency: clientInformation.defaultInvoiceFrequencyName || prev.invoiceFrequency,
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientInformation])

    useEffect(() => {
        if(dynamicInvoiceRate !== undefined && dynamicInvoiceRate !== null) {

            //setFormData({ ...formData, calculatedInvoiceRate: 12.25 })
            setFormData({ ...formData, calculatedInvoiceRate: dynamicInvoiceRate?.calculatedInvoiceRate })
            let data = [...tableData];
            Object.keys(dynamicInvoiceRate).map(x => {
                data.filter(y => { if(y.prop === x){
                        y.rate = formatNumberAmount(dynamicInvoiceRate[x], 'en-US', 2, 2)
                        y.amount = formatNumberAmount(dynamicInvoiceRate[x + "Value"], 'en-US', 2, 2)
                        return y;
                    } 
                });
            })
        }
    }, [dynamicInvoiceRate])

    return (<>
        <ConfirmAlert confirmAlert={confirmAlert}
                setConfirmAlert={setConfirmAlert}
            />
        <Container fluid className="main-content-container p-0">
            <Form onSubmit={onSubmit}>
                <ActionBar id="payItem" className="mb-4">
                    <Button className="my-2 py-2 mx-1" size="sm"
                        theme="accent" name="save"
                    >Save</Button>
                    <Button className="my-2 py-2 mx-1" size="sm"
                        theme="danger" name="delete"
                    onClick={onDelete}
                    >Delete</Button>
                    <Button onClick={back}
                        className="my-2 py-2 mx-1" size="sm"
                        theme="accent">Cancel</Button>
                </ActionBar>

                <div className="px-3">
                    <Card small className="mb-4 w-100">
                        <h4 className="m-0 section-title idStyle">Ref# {formData.payItemRefNum}</h4>
                        <ListGroup flush>
                            <ListGroupItem className="border-card p-3">
                                <Row>
                                    <Col>
                                        <label><b> General </b></label>
                                    </Col>
                                </Row>
                                <Row className="pl-3 pr-2"> 
                                    <Col lg="3" className="form-group m-0 p-2">
                                        <label htmlFor="payComponentId">Pay Component{payItem.payComponentId?.isChangeRequested && <CRBadge newValue={payItem.payComponentId?.newvalue} />}</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <FormSelect
                                            required={true}
                                            value={formData.payComponentId}
                                            id="payComponentId"
                                            name='payComponentId'
                                            onChange={onChange}
                                            className='d-block'>
                                            <option value=''>Select Pay Component
                                            </option>
                                            {newPayComponentNameListOptions}
                                        </FormSelect>
                                    </Col>
                                    <Col sm="3"
                                        className="form-group p-2 m-0">
                                        <label htmlFor="startDate">Start Date{payItem.startDate?.isChangeRequested && <CRBadge newValue={payItem.startDate?.newvalue} />}</label>
                                        <DatePicker
                                            id='startDate'
                                            autoComplete='off'
                                            name='startDate'
                                            dateFormat='yyyy-MM-dd'
                                            value={formData.startDate}
                                            selected={formData.startDate}
                                            onChange={(date) =>
                                                setFormData({ ...formData, 'startDate': date })
                                            }
                                            placeholderText="YYYY-MM-DD"
                                            maxDate={formData.endDate}
                                        />
                                    </Col>
                                    <Col sm="3"
                                        className="form-group p-2 m-0">
                                        <label htmlFor="endDate">End Date{payItem.endDate?.isChangeRequested && <CRBadge newValue={payItem.endDate?.newvalue} />}</label>
                                        <DatePicker
                                            id='endDate'
                                            autoComplete='off'
                                            name='endDate'
                                            dateFormat='yyyy-MM-dd'
                                            value={formData.endDate}
                                            selected={formData.endDate}
                                            onChange={(date) =>
                                                setFormData({ ...formData, 'endDate': date })
                                            }
                                            placeholderText="YYYY-MM-DD"
                                            minDate={formData.startDate}
                                        />
                                    </Col>
                                    <InputBox id="taxRate" name="taxRate" label={<>Tax Rate (%){payItem.taxRate?.isChangeRequested && <CRBadge newValue={payItem.taxRate?.newvalue} />}</>}
                                        value={formData.taxRate} onChange={(e) => onMonetaryAmountChanged(e, 4)}
                                        placeholder="0.0000" />
                                </Row>
                                <hr />


                                <Row>
                                    <Col>
                                        <label><b> Payable and Payment Setup </b></label>
                                    </Col>
                                </Row>
                                <Row className="pl-3 pr-2">
                                    <StandardFormInput
                                        id="payRate"
                                        name="payRate"
                                        standardFormat={STANDARD_FORMATS.COMMA_SEPERATED_NUMBER}
                                        label={<>Payable Rate{payItem.payRate?.isChangeRequested && <CRBadge newValue={payItem.payRate?.newvalue} />}</>}
                                        required={true}
                                        dataMaxFracDigits="4"
                                        value={formData.payRate}
                                        onChangeStandardInput={onChangeStandardInput}
                                        //placeholder="Enter Pay Rate"
                                        //align={(formData.payRate === '') ? 'left' : 'right'}
                                        //placeholder={"0.0000"}
                                        align={'right'}
                                    />

                                    <Col lg="3" className="form-group m-0 p-2">
                                        <label htmlFor="payableRateUnitOfMeasure">Payable Rate Unit of Measure{payItem.payableRateUnitOfMeasure?.isChangeRequested && <CRBadge newValue={payItem.payableRateUnitOfMeasure?.newvalue} />}</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <FormSelect
                                            required={true}
                                            value={formData.payableRateUnitOfMeasure}
                                            id="payableRateUnitOfMeasure"
                                            name='payableRateUnitOfMeasure'
                                            onChange={onChange}
                                            className='d-block'>
                                            <option value=''>Select Rate Unit of Measure
                                            </option>
                                            {rateUnitofMeasureNameListOptions}
                                        </FormSelect>
                                    </Col>

                                    <Col lg="3" className="form-group m-0 p-2">
                                        <label htmlFor="payFrequency">Payable Frequency{payItem.payFrequency?.isChangeRequested && <CRBadge newValue={payItem.payFrequency?.newvalue} />}</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <FormSelect
                                            required={true}
                                            value={formData.payFrequency}
                                            id="payFrequency"
                                            name='payFrequency'
                                            onChange={onChange}
                                            className='d-block'>
                                            <option value=''>How often item is paid out</option>
                                            {payFrequencyListOptions}
                                        </FormSelect>
                                    </Col>
                                    <Col sm="3"
                                        className="form-group p-2 m-0">
                                        <label htmlFor="payDate">Payable Date{payItem.payDate?.isChangeRequested && <CRBadge newValue={payItem.payDate?.newvalue} />}</label>
                                        <DatePicker
                                            id='payDate'
                                            autoComplete='off'
                                            name='payDate'
                                            dateFormat='yyyy-MM-dd'
                                            value={formData.payDate}
                                            selected={formData.payDate}
                                            onChange={(date) =>
                                                setFormData({ ...formData, 'payDate': date })
                                            }
                                            placeholderText="YYYY-MM-DD"
                                        />
                                    </Col>

                                    <Col sm="3"
                                        className="form-group p-2 m-0">
                                        <label htmlFor="defaultCompensationMethod">Default Compensation Method{payItem.defaultCompensationMethod?.isChangeRequested && <CRBadge newValue={payItem.defaultCompensationMethod?.newvalue} />}</label>
                                        <FormSelect
                                            value={formData.defaultCompensationMethod}
                                            id="defaultCompensationMethod"
                                            name='defaultCompensationMethod'
                                            onChange={onChange}
                                            className='d-block'>
                                            <option value="">Select Payee</option>
                                            {compensationPayeeListOptions}
                                        </FormSelect>
                                    </Col>

                                    <Col lg="3" className="form-group m-0 p-2">
                                        <label htmlFor="paySchedule">Pay Schedule{payItem.paySchedule?.isChangeRequested && <CRBadge newValue={payItem.paySchedule?.newvalue} />}</label>
                                        {/* <span aria-hidden="true" className="required"> *</span> */}
                                        <FormSelect
                                            value={formData.paySchedule}
                                            id="paySchedule"
                                            name='paySchedule'
                                            onChange={onChange}
                                            className='d-block'>
                                            <option value=''>Select Pay Schedule</option>
                                            {payScheduleListOptions}
                                        </FormSelect>
                                    </Col>

                                    <Col sm="3" className="form-group p-2 m-0">
                                        <label htmlFor="currentPaySchedule">Current Pay Schedule</label>
                                        
                                        <FormInput size="sm" readonly="true"
                                            placeholder={formData.currentPaySchedule > 0 && payScheduleList.length > 0 
                                                ? payScheduleList.filter(x => x.payScheduleRefNum === formData.currentPaySchedule)[0]?.payScheduleName : ""} 
                                        />
                                    </Col>
                                </Row>
                                <hr />

                                <Row>
                                    <Col>
                                        <label><b> Invoice Setup </b></label>
                                    </Col>
                                </Row>
                                <Row className="pl-3 pr-2"> 
                                    <StandardFormInput
                                        id="invoiceRate"
                                        name="invoiceRate"
                                        standardFormat={STANDARD_FORMATS.COMMA_SEPERATED_NUMBER}
                                        label={<>Base Invoice Rate{payItem.invoiceRate?.isChangeRequested && <CRBadge newValue={payItem.invoiceRate?.newvalue} />}</>}
                                        required={true}
                                        dataMaxFracDigits="4"
                                        value={formData.invoiceRate}
                                        onChangeStandardInput={onChangeStandardInput}
                                        //placeholder="Enter Employer Rate"
                                        //align={(formData.invoiceRate === '')? 'left' : 'right'}
                                        placeholder="0.0000"
                                        align={'right'}
                                    />

                                    <Col lg="3" className="form-group m-0 p-2">
                                        <label htmlFor="rateUnitOfMeasure">Invoice Rate Unit of Measure{payItem.rateUnitOfMeasure?.isChangeRequested && <CRBadge newValue={payItem.rateUnitOfMeasure?.newvalue} />}</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <FormSelect
                                            required={true}
                                            value={formData.rateUnitOfMeasure}
                                            id="rateUnitOfMeasure"
                                            name='rateUnitOfMeasure'
                                            onChange={onChange}
                                            className='d-block'>
                                            <option value=''>Select Rate Unit of Measure</option>
                                            {rateUnitofMeasureNameListOptions}
                                        </FormSelect>
                                    </Col>

                                    <Col lg="3" className="form-group m-0 p-2">
                                        <label htmlFor="invoiceFrequency">Invoice Frequency{payItem.invoiceFrequency?.isChangeRequested && <CRBadge newValue={payItem.invoiceFrequency?.newvalue} />}</label>
                                        <span aria-hidden="true" className="required"> *</span>
                                        <FormSelect
                                            required={true}
                                            value={formData.invoiceFrequency}
                                            id="invoiceFrequency"
                                            name='invoiceFrequency'
                                            onChange={onChange}
                                            className='d-block'>
                                            <option value=''>How often item is invoiced</option>
                                            {invoiceFrequencyListOptions}
                                        </FormSelect>
                                    </Col>
                                    <Col sm="3"
                                        className="form-group p-2 m-0">
                                        <label htmlFor="invoiceDate">Invoice Date{payItem.invoiceDate?.isChangeRequested && <CRBadge newValue={payItem.invoiceDate?.newvalue} />}</label>
                                        <DatePicker
                                            id='invoiceDate'
                                            autoComplete='off'
                                            name='invoiceDate'
                                            dateFormat='yyyy-MM-dd'
                                            value={formData.invoiceDate}
                                            selected={formData.invoiceDate}
                                            onChange={(date) =>
                                                setFormData({ ...formData, 'invoiceDate': date })
                                            }
                                            placeholderText="YYYY-MM-DD"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <div>
                                            <div className={"d-flex text-bold payItem_checkbox_padding"} >
                                                <FormCheckbox checked={ formData.includePayRateInInvoiceRate } 
                                                    value={formData.includePayRateInInvoiceRate}
                                                    id="includePayRateInInvoiceRate"
                                                    name='includePayRateInInvoiceRate'
                                                    onChange={() => {
                                                        setFormData({ ...formData, includePayRateInInvoiceRate: !formData.includePayRateInInvoiceRate })
                                                    } }
                                                >
                                                    <>Include Pay Rate as a Component of the Final Calculated Invoice Rate
                                                    {payItem.includePayRateInInvoiceRate?.isChangeRequested &&
                                                        <CRBadge newValue={payItem.includePayRateInInvoiceRate?.newvalue === 'true' ? 'True' : 'False'} />}
                                                    </>
                                                </FormCheckbox>
                                            </div>
                                        </div>
                                        
                                        <div className="">
                                            <ReactTable
                                                ref={tableRef}
                                                columns={tableColumns}
                                                data={tableData}
                                                pageSize={Number(5)}
                                                showPageSizeOptions={false}
                                                resizable={false}
                                                pagination={false}
                                                showPaginationBottom={false}
                                                noDataText="No results found"
                                            />
                                        </div>
                                    </Col>
                                    <Col lg="4">
                                        <div align="center">
                                            <Button className="my-2 py-2 mt-5 mx-1" size="sm" theme="accent" onClick={onCalculatingRates}>
                                                Calculate Rates
                                            </Button>
                                        </div>
                                        <div align="center">
                                            <label>(Click button above to calculate rates.)</label>
                                        </div>
                                        <div align="center">
                                            <label><b> Calculated {formData.rateUnitOfMeasure} Invoice Rate: {formatNumberAmount(formData.calculatedInvoiceRate, 'en-US', 2, 2)} </b></label>
                                        </div>
                                    </Col>
                                </Row>
                            </ListGroupItem>
                        </ListGroup>
                    </Card>
                </div>
            </Form>
        </Container>

    </>);
}

const mapStateToProps = (state) => (
    {
        newPayComponentNameList: state.payroll.newPayComponentNameList,
        rateUnitofMeasureNameList: state.payroll.rateUnitofMeasureNameList,
        payFrequencyList: state.payroll.payFrequencyList,
        payItem: state.payroll.payItem,
        recordFrequencyList:state.payroll.recordFrequencyList,
        payComponent:state.payroll.payComponent,
        compensationPayeeList:state.payroll.compensationPayeeList,
        subConfigList:state.user.subConfigList,
        payScheduleList: state.payroll.payScheduleList,
        clientAllowPaySchduleList: state.subscriberUsers.clientAllowPaySchduleList,
        currentPayItemPaySchedule: state.subscriberUsers.currentPayItemPaySchedule,
        dynamicInvoiceRate: state.payroll.dynamicInvoiceRate,
        clientInformation: state.user.clientInformation,
    }
)

export default connect(mapStateToProps, {
    get_new_payComponent_name_list,
    get_rate_unit_of_measure_name_list,
    get_record_frequency_list,
    save_pay_item,
    get_pay_item,
    delete_pay_items,
    reset_pay_item,
    get_pay_component,
    get_compensation_payee_list,
    get_compensation_payee_list_byworker,
    get_sub_config,
    get_pay_schedule_list,
    get_client_allowed_payschedule,
    get_current_payschedule,
    calculate_invoice_rate,
    get_client_information,
})(PayItemForm);